import type { BrindeFornecedor } from "../../../services/brindesFornecedor"

export type { BrindeFornecedor }

export type BrindesFornecedorModel = {
    brindes: BrindeFornecedor[]
}

export const BrindesFornecedorInicial: BrindesFornecedorModel = {
    brindes: [],
}
